import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import {
	actionDeleteSupportTicket,
	actionChangeSupportTicketProps,
	actionGetSupportTicketsList,
	actionGetUsersSupportList
} from "../../actions/SupportTicketActions";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	SUPPORT_TICKET_NEW,
	SUPPORT_TICKET_EDIT,
	INDEX
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import { Card, CardTitle, CardText } from "material-ui/Card";
import Util, { SUCCESS, ERROR } from "../../common/Util";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import FilterCard from "../../components/FilterCard/FilterCard";
import Paginator from "../../components/Paginator/Paginator";
import {
	ROL_EMPRESA,
	ROL_SOPORTE,
	ESTADO_SUPPORT_TICKET_CANCELADO,
	ESTADO_SUPPORT_TICKET_RESUELTO
} from "../../common/Constants";

let limitePagina = 10;

class SupportTicketsIndex extends Component {
	constructor(props) {
		super(props);
		// this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.getSupportTickets = this.getSupportTickets.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.renderBodyRows = this.renderBodyRows.bind(this);
		this.renderPaginator = this.renderPaginator.bind(this);
		this.onChangeSearch = this.onChangeSearch.bind(this);
		this.handleKeyPressSearchInput = this.handleKeyPressSearchInput.bind(this);
	}

	componentWillMount() {
		if (this.props.rol === ROL_EMPRESA) {
			this.props.history.push(INDEX);
		} else {
			this.getSupportTickets(1, limitePagina, null);
			this.props.actionGetUsersSupportList();
		}
	}

	getSupportTickets(page, limit) {
		let { searchtext } = this.props;
		this.props.actionGetSupportTicketsList(searchtext, page, limit);
	}

	renderPaginator() {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	}
	onChangeSearch({ target: { value } }) {
		this.props.actionChangeSupportTicketProps({ searchtext: value });
	}

	handleKeyPressSearchInput(e) {
		if (e.key === "Enter") {
			this.handleSearch();
		}
	}

	handleSearch() {
		this.props.actionChangeSupportTicketProps({
			page: 1
		});
		this.getSupportTickets(1, limitePagina);
	}

	onCreateOrUpdate(supportTicket) {
		if (supportTicket) {
			this.props.actionChangeSupportTicketProps({
				supportTicket: supportTicket,
				modeCRU: MODE_CRU_UPDATE,
				searchtext: ""
			});
			this.props.history.push(SUPPORT_TICKET_EDIT);
		} else {
			this.props.actionChangeSupportTicketProps({
				supportTicket: null,
				modeCRU: MODE_CRU_CREATE,
				searchtext: ""
			});
			this.props.history.push(SUPPORT_TICKET_NEW);
		}
	}

	// handleDelete(supportTicket) {
	// 	AppMem.confirmDialog.open({
	// 		title: "Eliminar Ticket de Soporte",
	// 		messageConfirm: "¿Esta seguro que desea eliminar el ticket de soporte?",
	// 		onAccept: this.onTapConfirmDelete.bind(this, supportTicket.id)
	// 	});
	// }

	handleShow(supportTicket) {
		this.props.actionChangeSupportTicketProps({
			modeCRU: MODE_CRU_SHOW,
			supportTicket: supportTicket
		});
		this.props.history.push(SUPPORT_TICKET_EDIT);
	}

	onTapConfirmDelete(supportTicketId) {
		this.props.actionDeleteSupportTicket(
			supportTicketId,
			this.returnConfirmDelete.bind(this)
		);
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getSupportTickets(this.props.page, limitePagina);
			Util.showNoty(response, "Tiquet de soporte Eliminado");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al eliminar el tiquet de soporte");
		} else {
			Util.showNoty(response, "No se puede eliminar el tiquet de soporte.");
		}
	}

	renderBlank() {
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>No se encontraron resultados</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangeSupportTicketProps({
			page: page
		});
		this.getSupportTickets(page, limitePagina);
	}
	renderUserSupport(id) {
		let userDestination = "";
		_.map(this.props.usersSupportList, (user, i) => {
			if (_.toInteger(user.id) === id) userDestination = user.email;
		});
		return userDestination;
	}

	renderBodyRows(supportTicketsList) {
		let Edit = this.onCreateOrUpdate;
		// let Delete = this.handleDelete;
		const Show = this.handleShow;
		let userDestination = "";
		const currentUser = this.props.email;
		const rol = this.props.rol;
		return _.map(supportTicketsList, (item, i) => {
			let supportTicket = item;
			userDestination = this.renderUserSupport(supportTicket.idUserDestination);
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn>{supportTicket.id}</TableRowColumn>
					<TableRowColumn>
						{Util.formatDateToShowNotHour(supportTicket.date)}
					</TableRowColumn>
					<TableRowColumn
						style={
							supportTicket.status === ESTADO_SUPPORT_TICKET_CANCELADO
								? { color: "red" }
								: supportTicket.status === ESTADO_SUPPORT_TICKET_RESUELTO
									? { color: "green" }
									: { color: "blue" }
						}
					>
						{supportTicket.status}
					</TableRowColumn>
					<TableRowColumn>{supportTicket.emailUserOrigin}</TableRowColumn>
					<TableRowColumn>{userDestination}</TableRowColumn>
					<TableRowColumn>{supportTicket.text}</TableRowColumn>
					<TableRowColumn style={{ width: "20%" }}>
						{supportTicket.emailUserOrigin === currentUser ||
						rol === ROL_SOPORTE ? (
							<OptionsTableRowColumn
								handleEdit={() => Edit(item)}
								handleShow={() => Show(item)}
								showTooltip="Ver"
							/>
						) : (
							<OptionsTableRowColumn
								handleShow={() => Show(item)}
								showTooltip="Ver"
							/>
						)}
					</TableRowColumn>
				</TableRow>
			);
		});
	}

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						title="Tiquet de Soporte"
						subtitle="Agregue o Modifique Tiquet de Soporte"
					/>
					<CardText>
						{this.props.rol === ROL_SOPORTE ? (
							<FilterCard
								onChangeSearchField={this.onChangeSearch}
								InputValue={this.props.searchtext}
								onKeyPressSearchField={this.handleKeyPressSearchInput}
								labelSearchInput={"Buscar por Nro. de Tiquet"}
								onTouchTapSearch={() =>
									this.handleSearch(this.props.searchtext)
								}
							/>
						) : (
							<FilterCard
								onChangeSearchField={this.onChangeSearch}
								InputValue={this.props.searchtext}
								onKeyPressSearchField={this.handleKeyPressSearchInput}
								labelSearchInput={"Buscar por Nro. de Tiquet"}
								onTouchTapSearch={() =>
									this.handleSearch(this.props.searchtext)
								}
								onTouchTapNew={() => this.onCreateOrUpdate()}
							/>
						)}
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Nro. de Tiquet</TableHeaderColumn>
									<TableHeaderColumn>Fecha</TableHeaderColumn>
									<TableHeaderColumn>Estado</TableHeaderColumn>
									<TableHeaderColumn>Origen</TableHeaderColumn>
									<TableHeaderColumn>Destino</TableHeaderColumn>
									<TableHeaderColumn>Descripción</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "20%" }}>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.supportTicketsList)
									? this.renderBodyRows(this.props.supportTicketsList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.supportTicketsList)
						? this.renderPaginator()
						: ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		searchtext: store.supportTicket.searchtext,
		supportTicketsList: store.supportTicket.supportTicketsList,
		loadingText: store.supportTicket.loadingText,
		modeCRU: store.supportTicket.modeCRU,
		page: store.supportTicket.page,
		total: store.supportTicket.total,
		rol: store.app.rol,
		usersSupportList: store.supportTicket.usersSupportList,
		email: store.app.username
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDeleteSupportTicket,
			actionChangeSupportTicketProps,
			actionGetSupportTicketsList,
			actionGetUsersSupportList
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SupportTicketsIndex);



// WEBPACK FOOTER //
// ./src/screens/SupportTicket/SupportTicketIndex.js